(($) => {

    // large info cards load more button on mobile

    $('.alteration_button').on('click', function(){
        $('.large_card__single').addClass('active');
        $('.alteration_button').removeClass('active');
    });

    // faq style block opening and closing mobile & web, and resizing sorting between the two

    $('.faq_styled_items_block .primary__content .field_info_item').on('click', function(){
        if(window.innerWidth <= 1279){
            if(!$(this).hasClass('active')){
                $('.faq_styled_items_block .primary__content .field_info_item').removeClass('active');
                $('.faq_styled_items_block .primary__content .field_info_item .field_info__content').slideUp();
                $(this).children('.field_info__content').slideDown();
                $(this).addClass('active');
            }
            else{
                $('.faq_styled_items_block .primary__content .field_info_item .field_info__content').slideUp();
                $('.faq_styled_items_block .primary__content .field_info_item').removeClass('active');
            }
        }
    });

    $('.faq_styled_items_block .alternative__buttons .field_info_item').on('click', function(){
        $('.faq_styled_items_block .alternative__buttons .field_info_item').removeClass('active');
        $(this).addClass('active');
        $('.faqs_styled_items__container .primary__content .field_info__content').css('display', 'block');

        let version = $(this).attr("class").match(/\bfield_info_item--\S+/);
        version = version ? version[0] : '';

        if(version){
            $('.faqs_styled_items__container .primary__content .field_info_item').css('display', 'none');
            $('.faqs_styled_items__container .primary__content .' + version).css('display', 'block');
        }
    });

    $(window).on('resize', function(){
        if(window.innerWidth <= 1279){
            $('.faqs_styled_items__container .primary__content .field_info_item').css('display', 'block');
            $('.faqs_styled_items__container .primary__content .field_info_item').removeClass('active');
            $('.faqs_styled_items__container .primary__content .field_info__content').css('display', 'none');
        }
        else{
            $('.faqs_styled_items__container .alternative__buttons .field_info_item').removeClass('active');
            $('.faqs_styled_items__container .alternative__buttons .field_info_item--0').addClass('active');
            $('.faqs_styled_items__container .primary__content .field_info_item').removeClass('active');
            $('.faqs_styled_items__container .primary__content .field_info_item--0').addClass('active');
            $('.faqs_styled_items__container .primary__content .field_info_item').css('display', 'none');
            $('.faqs_styled_items__container .primary__content .field_info_item--0').css('display', 'block');
            $('.faqs_styled_items__container .primary__content .field_info__content').css('display', 'none');
            $('.faqs_styled_items__container .primary__content .field_info_item--0 .field_info__content').css('display', 'block');
        }
    });

    // image text slider carousel

    function image_and_text_slider_slick(){
        if($('.image_text_slider .row_of_image_text')[0]){
            $('.image_text_slider .row_of_image_text').slick({
                slidesToShow: 1,
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                infinite: false,
                pauseOnHover: false,
                mobileFirst: true,
                centerMode: false
            });
        }
    }

    function image_and_text_slider_slick_check(){
        if(window.innerWidth <= 1511 && !$('.image_text_slider .row_of_image_text').hasClass('slick-initialized')){
            image_and_text_slider_slick();
        }

        if(window.innerWidth >= 1512 && $('.image_text_slider .row_of_image_text').hasClass('slick-initialized')){
            $('.image_text_slider .row_of_image_text').slick('unslick');
        }
    }

    image_and_text_slider_slick_check();

    $(window).on('resize', function(){
        image_and_text_slider_slick_check();
    });

    // multi tabs component tabs open related block based on index

    let multi_tab_items = $('.multi_tabs_component .inner_blocks');
    let inner_blocks = multi_tab_items.children();

    function activateBlock(index){
        inner_blocks.removeClass('active');
        inner_blocks.addClass('interacted');
        inner_blocks.eq(index).addClass('active');
    }

    $('.multi_tabs_component .tab_single').on("click", function(){
        $('.multi_tabs_component .tab_single').addClass('interacted');
        $('.multi_tabs_component .tab_single').removeClass('active');
        $(this).addClass('active');
        let classes = $(this).attr('class');
        let match = classes.match(/tab_single--(\d+)/); // extract number
        if(match){
            activateBlock(match[1]);
        }
    })

    // multi tabs component carousel

    function image_text_slider_slick(){
        if($('.multi_tabs_component .tab_items')[0]){
            $('.multi_tabs_component .tab_items').slick({
                slidesToShow: 1,
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                infinite: true,
                pauseOnHover: false,
                mobileFirst: true,
                centerMode: false,
                focusOnSelect: true
            });
        }
    }

    function image_text_slider_slick_check(){
        if(window.innerWidth <= 1023 && !$('.multi_tabs_component .tab_items').hasClass('slick-initialized')){
            image_text_slider_slick();
        }

        if(window.innerWidth >= 1024 && $('.multi_tabs_component .tab_items').hasClass('slick-initialized')){
            $('.multi_tabs_component .tab_items').slick('unslick');
        }
    }

    image_text_slider_slick_check();

    $(window).on('resize', function(){
        image_text_slider_slick_check();
    });

    // hero april 2025 carousel

    if($('.page_hero_april_2025 .image_carousel')[0]){
        $('.page_hero_april_2025 .image_carousel').slick({
            slidesToShow: 1,
            arrows: true,
            variableWidth: true,
            cssEase: 'linear',
            dots: true,
            infinite: false,
            pauseOnHover: false,
            mobileFirst: true,
            centerMode: false,
            prevArrow: $('.image_prev'),
            nextArrow: $('.image_next')
        });
    }

    // hero april 2025 image swap on click

    $('.page_hero_april_2025 .navigation_item').on("click", function(){
        $('.page_hero_april_2025 .navigation_item').removeClass('active');
        $('.page_hero_april_2025 .large_image_item').removeClass('active');
        $(this).addClass('active');
        let classes = $(this).attr('class');
        let match = classes.match(/navigation_item--(\d+)/);
        if(match[1]){
            $('.page_hero_april_2025 .large_image_item--' + match[1]).addClass('active');
        }
    })

    function product_cards_carousel(){
        if($('.product_information_cards__container .product_information__items').length && $('.product_information_cards__container .product_information__items').children().length >= 4){
            $('.product_information_cards__container .product_information__items').slick({
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                infinite: false,
                pauseOnHover: false,
                mobileFirst: true,
                centerMode: false,
            });

        }
    }

    function product_cards_carousel_check(){

        if(window.innerWidth >= 768 && window.innerWidth <= 1511 && !$('.product_information_cards__container .product_information__items').hasClass('slick-initialized')){
            product_cards_carousel();
        }

        if((window.innerWidth <= 767 || window.innerWidth >= 1512 ) && $('.product_information_cards__container .product_information__items').hasClass('slick-initialized')){
            $('.product_information_cards__container .product_information__items').slick('unslick');
        }
    }

    product_cards_carousel_check();

    $(window).on('resize', function(){
        product_cards_carousel_check();
    });

    console.log($('.product_information_cards__container .product_information__items').children().length);

    if(($('.product_information_cards__container .product_information__items').length && $('.product_information_cards__container .product_information__items').children().length >= 4) || ($('.product_information_cards__container .product_information__items .slick-track').length && $('.product_information_cards__container .product_information__items .slick-track').children().length >= 4)){
        $('.product_information_cards__container, .product_information_cards__container .contact_area').addClass('slider');
    }

})(jQuery);